import { useBundleSpecial } from '@/hooks';
import { evaluate } from '@/utils';
import { Heading } from '@/components';
import {
  ISpecial,
  PromoCarouselDocumentDataCarouselItemsItemWithID,
} from '@/types';
import { useSpecialsContext } from '@/context';
import styles from './specialbanner.module.scss';
import { asText } from '@prismicio/client';

interface ISpecialBanner {
  bundleId: string;
}

const SpecialBanner = ({ bundleId }: ISpecialBanner) => {
  const { activesPreCartDiscounts } = useSpecialsContext();
  const { special: treezPreCartDiscount } = useBundleSpecial({ id: bundleId });

  const formatDiscount = (special?: ISpecial): ISpecial => {
    if (!special) return {} as ISpecial;

    // replace underscores with spaces in method field e.g. TARGET_PRICE -> TARGET PRICE
    return { ...special, method: special?.method?.replace(/_/g, ' ') };
  };

  if (!bundleId) return null;

  const cmsDiscountItem = activesPreCartDiscounts?.[bundleId] as
    | PromoCarouselDocumentDataCarouselItemsItemWithID
    | undefined;

  // If we have CMS data, use evaluate to merge it with Treez data
  const evaluateSpecial =
    cmsDiscountItem &&
    evaluate(cmsDiscountItem, formatDiscount(treezPreCartDiscount));

  const title =
    evaluateSpecial?.title ||
    evaluateSpecial?.pos_title_name ||
    treezPreCartDiscount?.title;

  const description = evaluateSpecial?.description?.length
    ? asText(evaluateSpecial.description)
    : treezPreCartDiscount?.description || treezPreCartDiscount?.method;

  return (
    <div className={styles.specialbanner}>
      <Heading className={styles.specialbanner__title} level={1}>
        {title}
      </Heading>
      <p>{description}</p>
    </div>
  );
};

export default SpecialBanner;
